import { booleanAttribute, Directive, EventEmitter, Input, Output } from '@angular/core';
import { TabNavItemState } from './tab-nav-item.component';

@Directive({
  selector: '[qpointTabNavMenuItem]',
  standalone: true
})
export class QPointTabNavMenuItemDirective {
  @Input() label: string;
  @Input() internalFunction?: TabNavItemState;
  @Input({transform: booleanAttribute}) disabled = false;
  @Output() itemClicked = new EventEmitter();
}
